<template>
  <v-app>
    <notifications group="foo"></notifications>
    <v-navigation-drawer permanent app :width="drawerwidth">
      <v-img :src="logo" class="logo" :height="64" contain />
      <LeftMenu :fsize="fontsize" />
    </v-navigation-drawer>
    <v-toolbar dark fixed color="primary" app>
      <v-toolbar-side-icon @click.stop="changewidth"></v-toolbar-side-icon>
      <v-toolbar-title>Welcome {{user.UserName || 'Guest'}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat v-if="user.length===0" @click="$router.push('/account')">
          <v-icon>person</v-icon>&nbsp; Login
        </v-btn>
        <v-btn flat v-if="user.phone" @click="$router.push('/settings')">
          <v-icon>person</v-icon>&nbsp;Account
        </v-btn>
        <v-menu offset-y v-if="user.phone">
          <v-toolbar-title slot="activator">
            <span>&nbsp;₹ {{balance}}</span>
            <v-icon dark>arrow_drop_down</v-icon>
          </v-toolbar-title>
          <v-list>
            <v-list-tile @click="$router.push('/passbook')">
              <v-list-tile-title>PassbooK (Topup)</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/passbookstatement')">
              <v-list-tile-title>PassbooK (Statement)</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/passbookwithdrawal')">
              <v-list-tile-title>PassbooK (Withdrawal)</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/withdrawaltobank')">
              <v-list-tile-title>Withdrawal to Bank</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <!-- <v-btn flat v-if="user.phone && isPayout" @click="payout = true">
          <v-icon>credit_card</v-icon>&nbsp; Payout
        </v-btn> -->
        <v-btn flat @click="$router.push('/loadmoney')">
          <v-icon>credit_card</v-icon>&nbsp; Load Money
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer style="background: #E0F7FA">
      <v-spacer></v-spacer>
      <v-card-actions class="justify-center">
        &copy; 2018 - Developed By
        <strong>&nbsp;Bonrix Software Systems.</strong>
      </v-card-actions>
    </v-footer>
    <Message />
    <v-dialog v-model="$root.loader" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please wait
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import LeftMenu from "./components/LeftMenu.vue";
import Message from "./components/Message";
import Print from "./components/PrintBill";
export default {
  name: "App",
  data() {
    return {
      drawerwidth: 260,
      fontsize: "1.5em",
      logo: require("./assets/logo.png"),
      commisions: [],
    };
  },
  computed: {
    isPayout() {
      return this.$store.getters.enablepayout;
    },
    user() {
      return this.$store.getters.user;
    },
    balance() {
      return this.$store.getters.balance;
    }
  },
  watch: {
    user(value) {
      if (value.phone) {
        this.$store.dispatch("getbalance");
      }
    }
  },
  components: {
    LeftMenu,
    Print,
    Message
  },
  methods: {
    changewidth() {
      let vm = this;
      if (vm.drawerwidth === 260) {
        vm.drawerwidth = 70;
        vm.fontsize = "2.5em";
        vm.logo = require("./assets/logo_single.png");
        return;
      }
      vm.fontsize = "1.5em";
      vm.drawerwidth = 260;
      vm.logo = require("./assets/logo.png");
    },
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    },
    fetch() {
      let vm = this;
      let url = "GetService_List";
      let rrdoc = { Service_Type: "rr", SubType: "*" };
      let ppdoc = { Service_Type: "pp", SubType: "*" };
      let dthdoc = { Service_Type: "dth", SubType: "*" };
      let bbdoc = { Service_Type: "bp", SubType: "bb" };
      let edoc = { Service_Type: "bp", SubType: "eb" };
      let gdoc = { Service_Type: "bp", SubType: "gb" };
      let lldoc = { Service_Type: "bp", SubType: "lb" };
      let wdoc = { Service_Type: "bp", SubType: "wb" };
      let cdoc = {
        MobileNo: "null",
        Password: "null",
        AuthKey: "null",
        User: "Guest",
        Source: "json"
      };
      vm.postman(rrdoc, url, "setrprovider");
      vm.postman(ppdoc, url, "setppprovider");
      vm.postman(dthdoc, url, "setdthprovider");
      vm.postman(bbdoc, url, "setbbprovider");
      vm.postman(edoc, url, "seteprovider");
      vm.postman(gdoc, url, "setgprovider");
      vm.postman(lldoc, url, "setllprovider");
      vm.postman(wdoc, url, "setwprovider");
      vm.postman(cdoc, "Commission_Details", "setcommissions");
      vm.postman(cdoc, "BalUpdate", "setbalance");
    },
    postman(doc, url, way) {
      let vm = this;
      vm.$store
        .dispatch("axiosget", {
          url: url,
          data: doc,
          way: way
        })
        .then(function(doc) {})
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  beforeMount() {
    let vm = this;
    vm.$store.dispatch("getuser");
    if (window.innerWidth < 1041) {
      vm.drawerwidth = 70;
      vm.fontsize = "2.5em";
      vm.logo = require("./assets/logo_single.png");
    }
  },
  mounted() {
    let vm = this;
    vm.fetch();
    vm.$store.dispatch("getuser");
  }
};
</script>

<style scoped>
.logo {
  background: #e0f7fa;
}
</style>

<style>
table tr td {
  white-space: nowrap !important;
  padding: 0px !important;
  height: 35px !important;
  padding-left: 10px !important;
  padding-right: 15px !important;
}
table tr th {
  padding: 0px !important;
  height: 20px !important;
  padding-left: 10px !important;
  padding-right: 15px !important;
}
table.v-table tbody td {
  border-right: 1px solid lightgray;
}
.v-table__overflow {
  overflow: auto !important;
}
</style>
